import { render, staticRenderFns } from "./NsImage.vue?vue&type=template&id=da794768&scoped=true&"
import script from "./NsImage.vue?vue&type=script&lang=js&"
export * from "./NsImage.vue?vue&type=script&lang=js&"
import style0 from "./NsImage.vue?vue&type=style&index=0&id=da794768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da794768",
  null
  
)

export default component.exports